import React from 'react';

import { LabelValue, withLabelTokenParsing } from '../common/Content.jsx';
import { TypeConfig as ItemMetaCommonTypeConfig } from '../common/ItemMeta.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function _ItemMeta(props) {
    const hasValue = !Utilities.isHTMLContentEmpty(props.content);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const ItemMeta = withLabelTokenParsing(_ItemMeta, (props, keyword, options) => {
    let data = props.itemData || props.data || {};
    if (data.Inventory && props.index < data.Inventory.length) {
        data = data.Inventory[props.index];
    }
    let replaceString = '';
    switch (keyword) {
        case Token.Inventory.Edition:
            if (!Utilities.isNullOrWhitespace(data.EditionNumber)) {
                replaceString = Token.getReplacementString(data.EditionNumber, options);
            }
            break;
        default:
            replaceString = Token.TypeParsing.inventory(props, keyword, options);
            break;
    }
    return replaceString;
});

const Tokens = (data) => {
    const currencyFormat = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
        Token.getWrappedTokenConfig('Edition Number', Token.Inventory.Edition),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getDimensionsTokenConfig('Dimensions', Token.Inventory.Dimensions),
        Token.getCurrencyTokenConfig('Retail Price', currencyFormat, Token.Inventory.Price)
    ]
};
const TypeConfig = {
    defaultDesign: (data) => `<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, token: Token.Inventory.Dimensions })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Price}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Inventory.Price })}`,
    panel: {
        ...ItemMetaCommonTypeConfig.panel,
        value: (data) => ItemMetaCommonTypeConfig.panel.value(TypeConfig.defaultDesign(data))
    }
};

export {
    ItemMeta as Component,
    Tokens,
    TypeConfig
}